export default __webpack_public_path__ + "static/media/Asset4_lrg.4ba52ab3.png";